import { API } from "@/lib/api";

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    /* */
  }
  if (!res.ok) {
    const err = new Error(payload?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const securityQa = {
  pool: () => call("/auth/security-questions/pool"),
  sample: () => call("/auth/security-questions/sample"),
  status: () => call("/auth/security-questions/status"),
  set: (qa) => call("/auth/security-questions/set", { method: "POST", body: { qa } }),
  initiateReset: (email) =>
    call("/auth/password-reset/initiate", { method: "POST", body: { email } }),
  completeReset: ({ reset_ticket, answers, new_password }) =>
    call("/auth/password-reset/complete", {
      method: "POST",
      body: { reset_ticket, answers, new_password },
    }),
};
